import React from 'react';
import { createRoot } from 'react-dom/client';

import 'highlight.js/styles/shades-of-purple.css';
import './style.css';

import App from './App';
import { loadDeepZoom } from './loadDeepZoom';
import { FRACTAL_DPR_CHANGE_EVENT } from './ResponsiveFractalCanvas';

// The browser harness exercises the actual production chunks and workers.
// Merely enabling the hook must not fetch the lazy engine.
if (new URLSearchParams(window.location.search).get('deepZoomTest') === '1') {
  window.__deepZoomTest = {
    load: loadDeepZoom,
    getCanvases: () => Array.from(document.querySelectorAll('canvas'))
      .filter(canvas => typeof canvas.__setFractalCamera === 'function'),
  };
}

const VIZ_POLL_INTERVAL_MS = 200;
const RENDER_EVENT = new CustomEvent('render');
let previousDevicePixelRatio = window.devicePixelRatio;

function renderVisibleFractalCanvases() {
  // A change in DPR alone may not fire a resize or media query event.
  // The existing viewport poll can notify responsive canvases without another timer.
  if (!Object.is(window.devicePixelRatio, previousDevicePixelRatio)) {
    previousDevicePixelRatio = window.devicePixelRatio;
    window.dispatchEvent(new Event(FRACTAL_DPR_CHANGE_EVENT));
  }
  const viewportHeight = window.innerHeight;
  const canvases = document.getElementsByTagName('canvas');
  [...canvases].forEach((canvas) => {
    const rect = canvas.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > viewportHeight) {
      // canvas is not visible
    } else {
      // canvas is visible
      canvas.dispatchEvent(RENDER_EVENT);
    }
  });
}

function renderVisibleFractalCanvasesForever() {
  renderVisibleFractalCanvases();
  setTimeout(() => {
    renderVisibleFractalCanvasesForever();
  }, VIZ_POLL_INTERVAL_MS);
}

// entry point (React 18+ createRoot API)
const container = document.getElementById('react-mount');
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
renderVisibleFractalCanvasesForever();
